module.exports = __webpack_public_path__ + "static/media/arrow-to-bottom.6e98a08c.svg";